import { useNavigate } from 'react-router-dom';
import Button from '../../components/button/Button';
import DisplayItems from '../../methods/displayItems/DisplayItems';
import Cube from '../../views/animations/cube/Cube';
import AbilityCart from '../../views/carts/abilityCart/AbilityCart';
import ImageCart from '../../views/carts/imageCart/ImageCart';
import Contact from '../../views/contact/Contact';
import ListView from '../skill-page/sections/ListView';

import { works } from '../works/data/data';
import pic01 from './sa.jpg';
import './style.css';
import { intro, responsibility, role, topics } from '../../data';

export default function HomePage(params) {
  const navigate = useNavigate();

  return (
    <div className="px-2 home">
      <div className="body">
        <div className="">
          <div className="grid grid-flow-row lg:grid-flow-col gap-3">
            <div className="leftPart text-white">
              <div className="heading">
                <h1 className="">
                  HI,
                  <br />
                  I'AM SAYEEM, <br />
                  SOFTWARE DEVELOPER
                </h1>
              </div>

              <div className="paragraph">
                <p className="text-secondary-300 text-sm md:text-lg">
                  Full Stack Developer / Frontend Expert
                </p>
              </div>
              <div className="paragraph">
                <p className="mb-4">{intro}</p>
                <p>{role}</p>
              </div>

              <div className="w-32 h-10 mx-auto lg:mx-0 lg:ml-12 lg:my-12 border border-secondary-200 hover:bg-secondary-300 hover:text-primary-800">
                <Button
                  onClicked={() => navigate('/contact')}
                  title="Contact me !"
                />
              </div>
            </div>
            <div className="rightPart  row-start-1 lg:col-start-2 centerX">
              <img
                className="w-auto max-h-[310px] rounded-sm  shadow-2xl"
                src={pic01}
                alt="pic"
              />
            </div>
          </div>
          <div className="pb-12 portfolio flex flex-col lg:flex-row">
            <div className="w-full lg:w-1/2">
              <div className="heading">
                <h1 className="text-secondary-300">My Portfolio</h1>
              </div>
              <div className="paragraph">
                <p>
                  A small gallery of recent projects, languages, skills and
                  experiences possess to me. I've collect some of my works and
                  contributions to the companies I worked on with amazing
                  people.
                </p>
              </div>
            </div>
            <div className="p-4  w-full lg:w-1/2">
              <Cube />
            </div>
          </div>

          <div className="pb-12 mySkills">
            <div className="flex flex-col-reverse lg:flex-row">
              <div className="leftPart w-full lg:w-7/12 ">
                <div className="responsibility">
                  <div className="heading ml-2">
                    <h1 className="text-secondary-300">What I do</h1>
                  </div>
                  <div className="listContainer">
                    <div className="ml-4">
                      <ListView list={responsibility} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="rightPart px-10 md:px-14 lg:px-4 py-16  w-full lg:w-5/12">
                <DisplayItems View={AbilityCart} items={topics} />
              </div>
            </div>
          </div>

          <div className="pb-12 myWorks">
            <div className="heading ml-4">
              <h1 className="text-secondary-300">My Works</h1>
            </div>
            <div className="my-4 sm:ml-16">
              <DisplayItems grid items={works} View={ImageCart} />
            </div>
          </div>
          {/* <div className="pb-12"><About /></div> */}
          <div>
            <Contact />
          </div>
        </div>
      </div>
    </div>
  );
}
